// extracted by mini-css-extract-plugin
export default {"form":"Form_form__psS5c","fieldset":"Form_fieldset__cBI4N","submit":"Form_submit__khcqq"};